import {remCalc} from '_themeUtils'

// ─── ProductInfo (Descrizione / Confezione / Spedizione e Resi drawer) ────────
const productInfo = {
    ProductInfo: {
        baseStyle: () => ({
            container: {
                w: '100%',
                flexDirection: 'column',
            },
            // Figma: gap between the "intro" blocks (Descrizione / Materiali e dettagli / …) is 56px (spacing.14).
            // Vertical padding is handled by the drawer body, so no py here (Figma 5655-4321 / 5847-11406).
            // pt sits on top of the shared tablist pb (20px) to reach the tablist→content gap this drawer
            // uses: 34px on mobile (14 + 20) and 36px on desktop (16 + 20). The Size Guide keeps the plain 20px.
            tabSection: {
                w: '100%',
                alignItems: 'flex-start',
                gap: 'spacing.14',
                pt: {base: remCalc(14), md: 'spacing.4'},
            },
            // Figma Confezione: title → text → image gap is 12px on mobile (5847-11430) and 20px on
            // desktop (5655-4345).
            tabSectionPackaging: {
                w: '100%',
                alignItems: 'flex-start',
                gap: {base: 'spacing.3', md: 'spacing.5'},
                pt: {base: remCalc(14), md: 'spacing.4'},
            },
            // Figma Spedizione e Resi (5655-4360 / 5847-11445): two heading+text blocks separated by 56px
            // (spacing.14). The blocks are grouped in PageContentSection so this outer gap applies between them.
            tabSectionShipmentReturns: {
                w: '100%',
                alignItems: 'flex-start',
                gap: 'spacing.14',
                pt: {base: remCalc(14), md: 'spacing.4'},
            },
            // Within a Spedizione e Resi block the heading → text gap is 12px (spacing.3).
            tabSubSectionShipmentReturns: {
                w: '100%',
                alignItems: 'flex-start',
                gap: 'spacing.3',
            },
            tabSubSection: {
                w: '100%',
                alignItems: 'flex-start',
                gap: 'spacing.3',
            },
            tabSubSectionMaterials: {
                w: '100%',
                alignItems: 'flex-start',
                gap: 'spacing.3',
            },
            tabSectionTitle: {
                textStyle: 'paragraphXl',
                fontWeight: 400,
            },
            tabModelName: {
                textStyle: 'paragraphSm',
                fontWeight: 400,
            },
            tabText: {
                textStyle: 'paragraphSm',
                fontWeight: 350,
            },
            tabTextBold: {
                textStyle: 'paragraphSm',
                fontWeight: 400,
            },
            antiWasteMaterialLabel: {
                textStyle: 'paragraphSm',
                fontWeight: 400,
                sx: {
                    a: {
                        textDecoration: 'underline',
                        _hover: {
                            textDecoration: 'underline',
                        },
                    },
                },
            },
        }),
    },
}

export default productInfo
